import { ValueGetterFunc } from "ag-grid-community";
import { OffHoursSchedule } from "@/services/cloudchipr.api";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const offHoursLastExecutionValueGetter: ValueGetterFunc<
  OffHoursSchedule
> = ({ data }) => {
  if (!data?.last_execution?.date) {
    return "-";
  }

  return `${formatDate(data.last_execution.date, { type: "dateTime" })} (UTC)`;
};
